module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "kit"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.page) ? _c('div', {
    staticClass: "kit-lead",
    domProps: {
      "innerHTML": _vm._s(_vm.page.kit.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "newsletter-subscribe"
  }, [(!_vm.success) ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": require("./NewsletterButton.svg"),
      "width": "43",
      "height": "43"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Send")])])]) : _c('div', [_c('h5', [_c('strong', [_vm._v("Success!")]), _c('br'), _vm._v("We'll be in touch!")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "circleHeader"
  }, [_c('div', [_c('h2', [_vm._v("Keep in Touch")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8ab2788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/participate/KeepInTouch.vue
// module id = 802
// module chunks = 1